"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrivateWidgetsService = void 0;
const common_1 = require("@wix/wix-vod-shared/common");
const widgets_1 = require("@wix/wix-vod-api-site-based/dist/src/private/services/widgets/widgets");
const to_error_1 = require("../../parsers/to-error");
class PrivateWidgetsService {
    constructor(httpClient) {
        this.httpClient = httpClient;
        this.updateWidgetSettings = (widgetId, settings) => this.privateWidgetsService
            .updateSettings(widgetId, (0, common_1.keysToSnakeCase)(settings))
            .then((response) => (0, common_1.keysToCamelCase)(response.data))
            .catch(to_error_1.toError);
        this.updateWidget = (widgetId, widgetMetadata) => this.privateWidgetsService
            .create(widgetId, (0, common_1.keysToSnakeCase)(widgetMetadata))
            .then((response) => (0, common_1.keysToCamelCase)(response.data))
            .catch(to_error_1.toError);
        this.privateWidgetsService = new widgets_1.PrivateWidgets(httpClient);
    }
}
exports.PrivateWidgetsService = PrivateWidgetsService;
//# sourceMappingURL=widgets.js.map